import React, { Component } from "react";
import { Card, CardBody, CardHeader, Col, Row, Modal, Button, ModalHeader, ModalFooter, ModalBody } from "reactstrap";
import { Link } from "react-router-dom";
import Spinner from "../spinner/index";
import ReactTable from "react-table";
import "react-table/react-table.css";
import "./AllScanResult.css"
import { configuration } from "../../src/appConfig";
import Axios from "axios";
import Swal from "sweetalert2";
import moment from 'moment';
import DatePicker from 'react-date-picker';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import Cookies from "js-cookie"
import axios from "axios";
import AutoComplete from "./common/AutoComplete";
import { token } from "../appTokenConfig";

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});

const currentDate = new Date();
const year = currentDate.getFullYear();
const month = String(currentDate.getMonth() + 1).padStart(2, '0');
const day = String(currentDate.getDate()).padStart(2, '0');
const formattedDate = `${year}-${month}-${day}`;
const cookieDate = Cookies.get("filterDate")
const cookiePageJump = Cookies.get("jumpPage")
const cookieEntriesLimit = Cookies.get("recordsPerPage")
const cookieAuthorizeFilter = Cookies.get("authorizeFilter")
const isDateChanged = Cookies.get("dateChanged")
const cookieLocation = Cookies.get("allScanLocation");

// Axios.defaults.headers.common['X-Auth-Token'] = localStorage.getItem('partnerId');


class AllScanRecords extends Component {
  state = {
    data: [],
    words: {},
    lang: "",
    previous_page: null,
    current_page: null,
    next_page: null,
    search: "",
    search_status: false,
    loading: false,
    result: [],
    searchNextPage: null,
    searchCurrentPage: null,
    searchPreviousPage: null,
    cookieSetDate: Cookies.get("cookieSetDate") ? Cookies.get("cookieSetDate") : "",
    recordsPerPage: cookieEntriesLimit ? cookieEntriesLimit : 10,
    authorizeFilter: cookieAuthorizeFilter ? cookieAuthorizeFilter : '',
    filterDate: isDateChanged ? cookieDate : formattedDate,
    jumpPage: cookiePageJump ? cookiePageJump : 1,
    inputValue: '',
    isDateChanged: false,
    location: cookieLocation ? cookieLocation : "",
    locationLoading: false,
    locationArr: [],
    searchStatus: false,
  };
  componentDidMount() {
    this.getVinList();
    this.getLang();
    this.getAllLocation()
    const currentDate = this.getCurrentUTCDate();
    const cookieSetDate = Cookies.get("cookieSetDate");

    if (currentDate !== cookieSetDate) {
      ["jumpPage", "filterDate", "authorizeFilter", "recordsPerPage", "cookieSetDate", "dateChanged", "allScanLocation"].forEach(Cookies.remove);
    } else {
      this.setState({
        jumpPage: Cookies.get("jumpPage") || 1,
        filterDate: Cookies.get("filterDate") || "",
        authorizeFilter: Cookies.get("authorizeFilter") || "",
        recordsPerPage: Cookies.get("recordsPerPage") || 10,
        cookieSetDate: cookieSetDate || currentDate,
        location: Cookies.get("allScanLocation") || "",
      }, () => {
        this.search(this.state.jumpPage, "onMount");
      });
    }
  }

  getCurrentUTCDate = () => {
    const now = new Date();

    // Get UTC-based month, day, and year
    const month = now.getUTCMonth() + 1; // getUTCMonth returns 0-11, adding 1 for human-readable format
    const day = now.getUTCDate(); // getUTCDate returns the day of the month
    const year = now.getUTCFullYear(); // getUTCFullYear returns the 4-digit year

    // Format the date as MM/DD/YYYY
    const formattedDate = `${month}/${day}/${year}`;

    return formattedDate;
  }
  getAllLocation = () => {
    this.setState({ locationLoading: true });
    let partnerId = localStorage.getItem("partnerId");

    // const headers = {
    //   Authorization: `Bearer ${token}`,
    // };
    let url = `${configuration.getLocation}?partner_id=${partnerId}`;
    Axios.get(url)
      .then((res) => {
        this.setState({ locationLoading: false });
        if (res.data.data.location && res.data.data.location.length) {
          const locationArray = res.data.data.location.map((name) => {
            return name.name;
          });
          this.setState({
            locationArr: locationArray,
          });
        }
      })
      .catch((err) => {
        this.setState({ locationLoading: false });
      });
  };

  getVinList = async (page, closeBtn, isSearchStatus) => {
    const { recordsPerPage } = this.state;
    this.setState({
      loading: true,
    })
    if (closeBtn) {
      this.setState({
        location: "",
        searchStatus: false
      })
    }
    if (!isSearchStatus) {
      this.setState({
        search_status: false
      })
    }
    page = page === undefined ? 1 : page
    const partnerId = localStorage.getItem("partnerId");
    if (partnerId) {

      // const url = configuration.resultTxt;
      const url = configuration.getVinRecordsPaginate;
      const response = await Axios.get(
        url + "?partnerId=" + partnerId + "&page=" + page
      ).catch((err) => {
      });
      if (response && response.data) {
        const totalRecords = parseInt(response.data.total_records);
        const totalPages = Math.ceil(totalRecords / recordsPerPage);
        this.setState({
          previous_page: response.data.previous_page ? response.data.previous_page : null,
          current_page: response.data.current_page ? response.data.current_page : 1,
          next_page: response.data.next_page ? response.data.next_page : null,
          jumpPage: response.data.current_page,
          loading: false,
          totalPages,
        })
      }
      if (
        response &&
        response.data &&
        response.data.result_data &&
        response.data.result_data.length > 0
      ) {
        this.setState({
          data: response.data.result_data,
        });
        if (!localStorage.getItem("selectedFile")) {
          localStorage.setItem("selectedFile", response.data.result_data[0].vin);
        }
      } else {
        this.setState({
          loading: false,
        })
        if (!response.data.result_data) {
          Toast.fire({
            type: "error",
            title: "Issue in JSON file",
          });
        }
      }
    } else {
      this.props.history.push("/login");
    }
  };

  loading = () => (
    // <div className="animated fadeIn pt-1 text-center">Loading...</div>
    <div className="text-center">
      <div className="spinner-border" role="status">
        <span className="sr-only">Loading...</span>
      </div>
    </div>
  );
  // for translate...
  getLang = () => {
    const base_url = window.location.origin;
    Axios.get(`${base_url}/lang.json`).then((res) => {
      this.setState({ words: res.data, lang: localStorage.getItem("lang") });
    });
  };
  lang = (word) => {
    const { lang, words } = this.state;
    return words[word] ? words[word][lang] : word;
  };
  static getDerivedStateFromProps(nextProps, prevState) {
    // alert(nextProps.lang+"123")
    if (nextProps.lang !== prevState.lang) {
      return { lang: nextProps.lang };
    } else return null;
  }
  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value
    })
    if (e.target.value.trim() === "") {
      this.setState({
        result: [],
        search_status: false
      })
    }
  }
  handleDateChange = (date) => {
    this.setState({ filterDate: date, jumpPage: 1 })
    Cookies.set("jumpPage", this.state.jumpPage)
    Cookies.set("dateChanged", true)
  }
  // api for search
  search = (nextPage, type) => {
    const { authorizeFilter, filterDate, recordsPerPage, jumpPage, location } = this.state;
    // if(this.state.search.trim()){
    this.setState({
      loading: true,
    })


    if (type !== "onMount") {
      Cookies.set("recordsPerPage", recordsPerPage)
      Cookies.set("authorizeFilter", authorizeFilter)
      Cookies.set("filterDate", filterDate !== null ? filterDate : "")
      Cookies.set("jumpPage", jumpPage)
      Cookies.set("cookieSetDate", this.getCurrentUTCDate())

      this.setState({ cookieSetDate: this.getCurrentUTCDate() })
    }

    const partnerId = localStorage.getItem("partnerId");
    var searchvarkey = encodeURIComponent(this.state.search.trim())
    let url = `${configuration.searchGetVinRecords}?partnerId=${partnerId}&page=${nextPage}&location=${location}`

    if (searchvarkey.trim()) {
      url = url + `&vin=${searchvarkey.trim()}`;
    }

    if (recordsPerPage) {
      url = url + `&limit=${recordsPerPage}`;
    }
    if (filterDate) {
      url = url + `&date=${moment(filterDate).format('YYYY-MM-DD')}`;
    }
    // if(authorizeFilter) {
    //   url = url + `&authorized=${authorizeFilter === '1' ? true : false}`;
    // }
    if (authorizeFilter == "2") {
      url = url + `&prio=${true}`;
    }
    else if (authorizeFilter) {
      url = url + `&authorized=${authorizeFilter === '1' ? true : false}`;
    }

    Axios.get(url)
      .then((res) => {
        if (res.data) {
          const totalRecords = parseInt(res.data.total_records);
          const totalPages = Math.ceil(totalRecords / recordsPerPage);
          this.setState({
            result: res.data.data,
            search_status: true,
            loading: false,
            searchNextPage: res.data.next_page,
            searchCurrentPage: res.data.current_page ? res.data.current_page : 1,
            searchPreviousPage: res.data.previous_page,
            totalPages,
          })
        }
        if (location.trim() && res.data.data) {
          Cookies.set("allScanLocation", location);
          this.setState({ searchStatus: true });
        }
      })
      .catch((err) => {
        // alert(err)
        Toast.fire({
          type: "error",
          title: "Something Went Wrong",
        });
      });
    // }
  }
  calculateNewPage = (currentPage, oldRecordsPerPage, newRecordsPerPage) => {
    const currentStartIndex = (currentPage - 1) * oldRecordsPerPage;
    return Math.floor(currentStartIndex / newRecordsPerPage) + 1;
  };

  handleFilterChange = (e) => {
    const { name, value } = e.target;
    const { current_page, recordsPerPage } = this.state;

    if (name == "recordsPerPage") {


      const newRecordsPerPage = parseInt(value, 10);
      const newPage = this.calculateNewPage(current_page, recordsPerPage, newRecordsPerPage);

      this.setState({
        [name]: newRecordsPerPage,
        current_page: newPage || null
      }, () => {
        this.search(newPage);
      });
    } else {
      this.setState({
        [name]: value
      });
    }
  };

  handleClearFilter = () => {
    this.setState({
      authorizeFilter: '',
      filterDate: '',
      recordsPerPage: 10,
      jumpPage: 1,
      location: ""
    }, () => this.search('1'))
    Cookies.set("jumpPage", 1)

  };

  handleInputChange = (e) => {
    this.setState({
      inputValue: e.target.value
    })
  }
  handleExperte = () => {
    const { inputValue, Expert_vin, current_page, search_status, searchCurrentPage, data, result } = this.state;
    const partnerId = localStorage.getItem('partnerId')
    const url = configuration.Update_ResultTxt;

    let payload = {
      partnerId: partnerId,
      vin: Expert_vin,
      expert_name: inputValue
    };

    Axios.post(url, payload).then((res) => {
      this.setState({
        modal: false
      }, () => {
        if (!search_status && data.length > 0) {
          this.getVinList(current_page);
        } else if (result.length && search_status) {
          this.search(searchCurrentPage)
        }

      })
    });
  }
  updateExpert = (order) => {
    this.setState({
      modal: true,
      Expert_vin: order.vin || order && order.resultTXT && order.resultTXT && order && order.resultTXT && order.resultTXT.ActualVin,
      inputValue: order.expert_name && order.expert_name
    })
  }
  handleChangeLocation = (stateData) => {
    if (stateData.userInput.trim() === "") {
      Cookies.remove("allScanLocation");
      this.getVinList();
      this.setState({
        search_status: false
      });
    }
    this.setState(
      {
        location: stateData.userInput,
      }
    );
  };

  formatDate = (dateString) => {
    return moment(dateString, 'YYYY-MM-DD').format((localStorage.getItem("client") == "US" || localStorage.getItem("client") == "CANADA") ? "MM/DD/YYYY" : "DD.MM.YYYY")
  };

  resetAuthorizeAPI = (vin) => {
    const url = configuration.resetAuthorized;
    const data = {
      partnerId: localStorage.getItem("partnerId"),
      vin: vin,
    };
    axios
      .post(url, data)
      .then((res) => {
        Toast.fire({
          type: "success",
          title: res.data.message,
        });
        window.location.reload()
      })
      .catch((error) => {
        Toast.fire({
          type: "error",
          title: error,
        });
      });
  };

  generateLink = (reportType, type) => {
    const client = localStorage.getItem('client');
    const partnerId = localStorage.getItem('partnerId');
    if (type === "Poland") {
      const basePaths = {
        TabView: {
          DNS: '/TabViewDNS',
          AUS: '/TabViewDNS',
          FR: '/TabViewSwissFrench',
          POLAND: '/PolandTabview',
          OTHER: '/TabView/slovani',
          ROM: '/TabView/romania',
          CZ: '/TabViewCZ',
          AUT: '/TabViewAUT',
          US: '/TabViewUS',
          CANADA: '/Canada/TabView'
        },
        ReportMini: {
          DNS: '/ReportMiniDNS',
          AUS: '/ReportMiniDNS',
          FR: '/ReportMiniSwissFrench',
          POLAND: '/PolandReportMini',
          OTHER: '/ReportMini/slovani',
          ROM: '/ReportMini/romania',
          CZ: '/ReportMiniCZ',
          AUT: '/ReportMiniAUT',
          US: '/ReportMiniUS',
          CANADA: '/Canada/ReportMini'
        },
        ReportFull: {
          DNS: (partnerId == "5-200126" || partnerId == "24-230315" || partnerId == "11-210601") ? '/ReportFullGeneralDamageImage' : '/ReportFullDNS',
          AUS: (partnerId == "5-200126" || partnerId == "24-230315" || partnerId == "11-210601") ? '/ReportFullGeneralDamageImage' : '/ReportFullDNS',
          FR: '/ReportFullSwissFrench',
          POLAND: '/PolandReportFull',
          OTHER: (partnerId == "5-200126" || partnerId == "24-230315" || partnerId == "11-210601") ? '/ReportFullGeneralDamageImage' : '/ReportFull/slovani',
          ROM: '/ReportFull/romania',
          CZ: '/ReportFullCZ',
          AUT: '/ReportFullAUT',
          US: '/ReportFullUS',
          CANADA: "/Canada/ReportFullCA"
        },
      };

      return basePaths[reportType][client] || '';
    } else {
      const basePaths = {
        TabView: {
          DNS: '/TabViewDNS',
          AUS: '/TabViewDNS',
          FR: '/TabViewSwissFrench',
          SWISS: '/newTabview',
          OTHER: '/TabView/slovani',
          ROM: '/TabView/romania',
          CZ: '/TabViewCZ',
          AUT: '/TabViewAUT',
          US: '/TabViewUS',
          CANADA: '/Canada/TabView'
        },
        ReportMini: {
          DNS: '/ReportMiniDNS',
          AUS: '/ReportMiniDNS',
          FR: '/ReportMiniSwissFrench',
          SWISS: '/newReportMini',
          OTHER: '/ReportMini/slovani',
          ROM: '/ReportMini/romania',
          CZ: '/ReportMiniCZ',
          AUT: '/ReportMiniAUT',
          US: '/ReportMiniUS',
          CANADA: '/Canada/ReportMini'
        },
        ReportFull: {
          DNS: (partnerId == "5-200126" || partnerId == "24-230315" || partnerId == "11-210601") ? '/ReportFullGeneralDamageImage' : '/ReportFullDNS',
          AUS: (partnerId == "5-200126" || partnerId == "24-230315" || partnerId == "11-210601") ? '/ReportFullGeneralDamageImage' : '/ReportFullDNS',
          FR: '/ReportFullSwissFrench',
          SWISS: '/newReportFull',
          OTHER: (partnerId == "5-200126" || partnerId == "24-230315" || partnerId == "11-210601") ? '/ReportFullGeneralDamageImage' : '/ReportFull/slovani',
          ROM: '/ReportFull/romania',
          CZ: '/ReportFullCZ',
          AUT: '/ReportFullAUT',
          US: '/ReportFullUS',
          CANADA: "/Canada/ReportFullCA"
        },
      };

      return basePaths[reportType][client] || '';
    }

  };

  render() {
    const client = localStorage.getItem('client');
    const partnerId = localStorage.getItem('partnerId');
    const { data, previous_page, current_page, next_page, loading, search_status, result, searchCurrentPage, searchNextPage, searchPreviousPage, recordsPerPage, filterDate, authorizeFilter, totalPages, jumpPage, search } = this.state
    let German_partnerId = ['002-sa', "1-190301-1", "6-200406", "8-200406-1", "16-220515", "WW-001", "demo-de", "23-230315", "23-230315-1", "HXAG-01"]
    let UsCanada_partnerId = ['10-200410', 'demo-us', '21-220515-1', "21-220515", "22-220515"]
    const columns = [
      {
        Header: this.lang("Sr. No"),
        id: "row",
        maxWidth: 60,
        className: "tr-srno",
        filterable: false,
        Cell: (row) => {
          return <div>{row.index + 1}</div>;
        },
      },
      {
        Header: this.lang("VIN"),
        filterable: true,
        width: 200,
        className: "tr-vinnumber",
        maxWidth: 300,
        accessor: "vin",

        Cell: (props) => (
          <span
            style={{ textAlign: "center" }}
          // onClick={() => {
          //   localStorage.setItem("selectedFile", props.row.vin);
          //   localStorage.setItem("userSession", "");
          //   this.props.history.push({
          //     pathname: "/CreateVin",
          //     search: "?vin=" + props.row.vin,
          //     state: { detail: props.row },
          //   });
          // }}
          >
            {props.value}
          </span>
        ),
      },
      {
        id: "Estimate Id", // Required because our accessor is not a string
        Header: this.lang("Estimate Id"),
        maxWidth: 200,
        className: "tr-estimateid",
        accessor: "orderNo",
        filterable: true,
        Cell: (props) => (
          <span
            style={{ textAlign: "center" }}
          // onClick={() => {
          //   localStorage.setItem("selectedFile", props.row.vin);
          //   localStorage.setItem("userSession", "");
          //   this.props.history.push({
          //     pathname: "/CreateVin",
          //     search: "?vin=" + props.row.vin,
          //     state: { detail: props.row },
          //   });
          // }}
          >
            {props.value}
          </span>
        ),
      },

      {
        id: "Make", // Required because our accessor is not a string
        Header: this.lang("Make"),
        maxWidth: 180,
        accessor: "make",
        filterable: true,
      },
      {
        id: "Model", // Required because our accessor is not a string
        Header: this.lang("Model"),
        maxWidth: 180,
        accessor: "modal",
        filterable: true,
      },
      {
        id: "Color", // Required because our accessor is not a string
        Header: this.lang("Color"),
        maxWidth: 180,
        accessor: "color",
        filterable: true,

      },



      {
        Header: () => <span>{this.lang("Reports")}</span>, // Custom header components!
        minWidth: 350,
        Cell: (props) => (
          <>
            <div className="all_scan_report_table_btn m-auto">
              <div className="d-flex justify-content-center">
                <span style={{}}>
                  <Link
                    className="btn btn-outline-info text-decoration-none mr-1 mt-1"
                    style={{ fontSize: 17 }}
                    to="/TabView"
                    target='_blank'
                    onClick={() => {
                      localStorage.setItem("selectedFile", props.row.vin);
                    }}
                  >
                    <i className="fa fa-table" aria-hidden="true"></i> Tab
                  </Link>
                </span>
                <span style={{}}>
                  <Link
                    className="btn btn-outline-info text-decoration-none mr-1 mt-1"
                    style={{ fontSize: 17 }}
                    to="/ReportMini"
                    target='_blank'
                    onClick={() => {
                      localStorage.setItem("selectedFile", props.row.vin);
                    }}
                  >
                    <i className="fa fa-file-text-o" aria-hidden="true"></i> Mini
                  </Link>
                </span>
                <span style={{}}>
                  <Link
                    className="btn btn-outline-info text-decoration-none mr-1 mt-1"
                    style={{ fontSize: 17 }}
                    to="/ReportFull"
                    target='_blank'
                    onClick={() => {
                      localStorage.setItem("selectedFile", props.row.vin);
                    }}
                  >
                    <i className="fa fa-file-pdf-o" aria-hidden="true"></i> Full
                  </Link>
                </span>
              </div>
              {/* <div className="col-lg-3">
            
            </div>
            <div className="col-lg-3">
            
            </div> */}
            </div>



          </>
        ),
      },

      {
        id: "Date", // Required because our accessor is not a string
        Header: this.lang("Scan Date"),
        maxWidth: 100,
        accessor: "uploadDate",
        Cell: (props) => (
          <span
          >
            {
              (props.value) ? (props.value).split(" ")[0] : ''
            }
          </span>
        ),
      },

      {
        id: "Time", // Required because our accessor is not a string
        Header: this.lang("Scan Time"),
        maxWidth: 100,
        accessor: "uploadDate",
        Cell: (props) => (
          <span
          >
            {
              (props.value) ? (props.value).split(" ")[1] : ''
            }
          </span>
        ),
      },

    ];
    const tableProps = {
      defaultPageSize: 5,
      filterable: false,
      defaultSortDesc: false,
      showPagination: true,
      showPageSizeOptions: false,
    };
    function filterCaseInsensitive(filter, row) {
      const id = filter.pivotId || filter.id;
      return row[id] &&
        String(row[id].toLowerCase()).startsWith(filter.value.toLowerCase())

    }
    return (
      <div className="animated fadeIn vin-list-table">
        {/* <Row> */}
        {/* <Col> */}
        {/* <div className="card m-0"> */}
        {/* <CardHeader> */}
        {/* <div className="row p-0"> */}
        {/* <Col lg-6> */}
        {/* <h4>{this.lang("Vin LIST")}</h4> */}
        {/* <h4>Vin LIST</h4> */}
        {/* </Col> */}
        {/* <Col lg-6>
                    <Link to="CreateVin">
                      <button
                        type="button "
                        className="btn btn-lg pull-right new-qr-btn"
                      >
                        <i className="mdi mdi-qrcode"></i> Create VIN
                      </button>
                    </Link>
                  </Col> */}
        {/* </div> */}
        {/* </CardHeader> */}
        {/* </div> */}
        {/* </Col> */}
        {/* </Row> */}
        {/* <Row>
          <Col>
            <Card>
              <div className="CardBody p-0">
                <ReactTable
                  id="t12"
                  style={{ textAlign: "center" }}
                  data={this.state.data}
                  columns={columns}
                  {...tableProps}
                  minRows={0}
                  defaultPageSize={15}
                  defaultFilterMethod={(filter, row) =>
                    filterCaseInsensitive(filter, row)
                  }
                />
              </div>
            </Card>
          </Col>
        </Row> */}
        <Row>
          <Col>
            <Card className="qr_list_table_main pt-2">
              <div className="CardBody p-0">
                {/* Table for QR list */}
                <div className="text-right searchbar_input">
                  <div className="row align-items-center justify-content-between">
                    <div className="col-lg-5 col-md-6 col-sm-12">
                      <h4 className="p-0 m-0 text-left">{this.lang("Vin LIST")}</h4>
                    </div>
                    <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 searchbar_input_main text-end pl-0">
                      <input
                        type="text"
                        name="search"
                        value={this.state.search}
                        className="form-control w-100 d-inline mx-3"
                        onChange={(e) => this.handleChange(e)}
                        onKeyPress={(e) => {
                          if (e.key === 'Enter') {
                            this.setState({
                              jumpPage: ''
                            }, () => {
                              this.search('1')
                            })
                          }
                        }} placeholder={this.lang("Search by VIN Number")} />
                      {search_status && search.trim() && <button
                        className="close_button main_close__search all-scan-record-btn"
                        onClick={() => {
                          this.setState({
                            search: '',
                          }, () => this.search('1'))
                        }}
                      >
                        {/* {this.lang("search")} */}
                        <i className="fa fa-close"></i>
                      </button>}
                      <button
                        className="search_icon_button"
                        onClick={() => {
                          this.setState({
                            jumpPage: '',
                          }, () => this.search('1'))
                        }}
                      >
                        {/* {this.lang("search")} */}
                        <i className="fa fa-search"></i>
                      </button>
                    </div>
                  </div>
                </div>
                {/* Filter: start */}
                <div className="row p-0 m-0 record_selection_row align-items-end justify-content-between">
                  <div className="col-lg-2 col-md-6 col-sm-12">
                    <div className="form-group">
                      <label>{this.lang('showEntries')}</label>
                      <select
                        className="form-control"
                        name='recordsPerPage'
                        onChange={(e) => this.handleFilterChange(e)}
                        value={recordsPerPage}
                      >
                        {[10, 20, 30, 40, 50, 100].map((e) => <option>{e}</option>)}
                      </select>
                    </div>
                  </div>
                  <div className="col-lg col-md-6 col-sm-12">
                    <div className="form-group">
                      <label className="d-block">{this.lang('selectDate')}</label>
                      {/* <input 
                            className="form-control"
                            type="date"
                            name="filterDate"
                            // value={filterDate}
                            value={this.formatDate(filterDate)}
                            onChange={this.handleFilterChange}
                          /> */}
                      <div className="main_datepicker_wrapper">
                        {
                          localStorage.getItem("client") == "US" || localStorage.getItem("client") == "CANADA" ?
                            <DatePicker
                              className="filter-date-picker"
                              value={filterDate ? new Date(filterDate) : null}
                              format="MM/dd/yyyy"
                              onChange={(date) => this.handleDateChange(date)}
                            />
                            :
                            <DatePicker
                              className="filter-date-picker"
                              value={filterDate ? new Date(filterDate) : null}
                              format="dd.MM.yyyy"
                              onChange={(date) => this.handleDateChange(date)}
                            />
                        }
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-2 col-md-6 col-sm-12">
                    <div className="form-group">
                      <label>{this.lang("pageJump")}</label>
                      <select
                        className="form-control"
                        name='jumpPage'
                        value={jumpPage}
                        onChange={(e) => this.handleFilterChange(e)}
                      >

                        {totalPages ?
                          Array.from({ length: totalPages }, (_, index) => index + 1).map((ele) => {
                            return <option>{ele}</option>
                          })
                          :
                          <option disabled>Option not available</option>
                        }
                      </select>
                    </div>
                  </div>
                  {(client === 'SWISS' || client === "POLAND" || client === "DNS" || UsCanada_partnerId.includes(partnerId)) && <div className="col-lg col-md-6 col-sm-12">
                    <div className="form-group">
                      <label>{this.lang("showRecord")}</label>
                      <select
                        className="form-control"
                        name="authorizeFilter"
                        value={authorizeFilter}
                        onChange={(e) => this.handleFilterChange(e)}
                      >
                        <option value=''>{this.lang("All")}</option>
                        <option value={1}>{this.lang('Authorize')}</option>
                        <option value={0}>{this.lang("De-Authorize")}</option>
                        {(client === 'SWISS' || client === "POLAND" || UsCanada_partnerId.includes(partnerId)) && <option value={2}>{this.lang("Prio")}</option>}
                      </select>
                    </div>
                  </div>}
                  {/* <div className="col-lg-2 col-md-6 col-sm-12">
                      <div className="form-group">
                          <label>{this.lang("Insurance Client")}</label>
                          <select 
                            className="form-control"
                            name="authorizeFilter"
                            value={authorizeFilter}
                            onChange={(e) => this.handleFilterChange(e)}
                            >
                              <option value=''>1</option>
                              <option value=''>2</option>
                              <option value=''>3</option>
                              <option value=''>4</option>
                          </select>
                      </div>
                  </div> */}
                  <div className="col-lg col-md-6 col-sm-12">
                    <div className="form-group position-relative location-dropdown-wrapper">
                      <AutoComplete
                        value={this.state.location}
                        data={this.state.locationArr}
                        handleChange={this.handleChangeLocation}
                        placeholder={this.lang("searchByLocation")}
                        label={this.lang("Location")}
                        // _onSearchForDataPress={this._onSearchForDataPress}
                        getOrders={this.getVinList}
                        searchStatus={this.state.searchStatus}
                        locationLoading={this.state.locationLoading}
                        isDashboard={false}
                      />

                      {this.state.locationLoading && (
                        <div className="input-group-prepend vertical-align-middle align-item-center ml-2">
                          <Spinner />
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-lg col-md-6 col-sm-12">
                    <div className="form-group text-right">
                      <label style={{ cursor: "pointer" }} onClick={() => this.handleClearFilter()}><i className="fa fa-close text-black"></i> {this.lang("clearAllFilters")}</label>
                      <button className="btn main_search_button" onClick={() => this.search(this.state.jumpPage ? this.state.jumpPage : 1)} disabled={loading}>
                        <i className="fa fa-search" aria-hidden="true"></i> {this.lang("Search")}
                      </button>
                    </div>
                  </div>
                </div>

                {/* Filter: end */}

                <div className="row">
                  <div className="col-lg-12 p-0">
                    <div className="qr_listing_main all_scan_record_wrapper">
                      <table className="table table-bordered table-responsive-md qr_list_table">
                        <thead>
                          <tr>
                            <th scope="col" className={`${(client === 'SWISS' || client === "POLAND") ? 'sr_no_row' : ''}`}>{this.lang("Sr. No")}</th>
                            <th scope="col">{(client === 'SWISS' || client === "POLAND") ? this.lang("Order NO") : this.lang("VIN")}</th>
                            {/* {(client === 'SWISS' || client === "POLAND") && <th scope="col">{this.lang("Actual VIN")}</th>} */}
                            <th scope="col" className={`${(client === 'SWISS' || client === "POLAND") ? 'insurance_client_row' : ''}`}>{(partnerId === "HXAG-01" || partnerId === "8-200406-1" || partnerId === "1-190301-1" || partnerId === "6-200406" || partnerId === "002-sa"
                              || partnerId === "16-220515" || partnerId === "WW-001" || partnerId === "demo-de" || partnerId === "23-230315" || partnerId === "23-230315-1" || partnerId === "7-200406") ? this.lang("Schadennumber") : client === 'SWISS' || client === 'POLAND' ? this.lang("Contractor") : this.lang("Estimate Id")}</th>
                            {(client === 'SWISS' || client === "POLAND") &&
                              <th scope="col" className="drive_through_row">
                                {this.lang("Customer Company")}
                              </th>
                            }
                            {/* {((client === 'SWISS' || client === "POLAND") || client === "DNS" || UsCanada_partnerId.includes(partnerId)) &&   */}
                            <th scope="col" className="prio_row">
                              {this.lang("Prio")}
                            </th>
                            {/* } */}
                            {/* {((client === 'SWISS' || client === "POLAND") || client === "DNS" || UsCanada_partnerId.includes(partnerId)) &&  */}
                            <th scope="col" className="drive_through_row">
                              {this.lang("Drive In/Th")}
                            </th>
                            {/* } */}

                            <th scope="col" className={`${(client === 'SWISS' || client === "POLAND") ? 'modal_row' : ''}`}>{this.lang("Make")}</th>
                            <th scope="col" className={`${(client === 'SWISS' || client === "POLAND") ? 'modal_row' : ''}`}>{this.lang("Model")}</th>
                            {(client === 'SWISS' || client === "POLAND" || UsCanada_partnerId.includes(partnerId)) && <th scope="col" className="expert_name_column">{this.lang("Experte")}</th>}
                            <th scope="col">{(client === 'SWISS' || client === "POLAND") ? this.lang("Authorizer name") : this.lang("Color")}</th>

                            { client === "POLAND" && <>
                               <th scope="col" >{this.lang("Location")}</th>
                               <th scope="col" >{this.lang("Revision")}</th>
                            </>
                            }
                            <th scope="col" className="date_row">{this.lang("Date")}</th>
                            <th scope="col" className="time_row">{this.lang("Time")}</th>
                            <th scope="col" className={`${(client === 'SWISS' || client === "POLAND") ? 'counts_row' : ''}`}>{this.lang("Dents")}</th>
                            <th scope="col" className={`${(client === 'SWISS' || client === "POLAND") ? 'counts_row' : ''}`}>{this.lang("Images")}</th>
                            <th scope="col" className={`${(client === 'SWISS' || client === "POLAND") ? 'counts_row' : ''}`}>{this.lang("extraImage")}</th>
                            <th scope="col" className={`${(client === 'SWISS' || client === "POLAND") ? 'last_report_row' : ''}`}>{this.lang("Reports")}</th>
                            {(client === 'SWISS' || client === "POLAND") && <th scope="col" className=''>{this.lang("Images")}</th>}
                          </tr>
                        </thead>
                        <tbody>
                          {loading &&
                            <tr>
                              <td className="sr_no_row" colSpan={'15'}>{this.loading()}</td>
                            </tr>
                          }
                          {!search_status && !loading && data.length > 0 ?
                            data.map((order, i) => {
                              return (
                                <tr key={i}>
                                  <td className={`${(client === 'SWISS' || client === "POLAND") ? 'sr_no_row' : ''}`}>{(current_page - 1) * (recordsPerPage ? parseInt(recordsPerPage) : 10) + i + 1}</td>
                                  <td onClick={() => {
                                        localStorage.setItem("selectedVin", order.vin); // Save VIN to localStorage
                                        localStorage.setItem("userSession", ""); // Clear user session
                                        localStorage.setItem("searchFlag", "true");
                                        this.props.history.push("/dashboard"); // Redirect to dashboard
                                      }}
                                    style={{ color: ((order && order.resultTXT && order.resultTXT.DriveThrough == "1" || order && order.resultTXT && order.resultTXT.DriveThrough == "0") && order && order.resultTXT && order.resultTXT.ReportGenerated == true ? "#006400" : "#F20000"), cursor:"pointer" }}  >
                                    {order.vin || order && order.resultTXT && order.resultTXT && order && order.resultTXT && order.resultTXT.ActualVin}</td>
                                  {/* {(client === 'SWISS' || client === "POLAND") && <td scope="col">{order && order.resultTXT && order.resultTXT && order && order.resultTXT && order.resultTXT.ActualVin}</td>} */}
                                  <td className={`${(client === 'SWISS' || client === "POLAND") ? 'insurance_client_row' : ''}`} title={order.client}>{(client === 'SWISS' || client === "POLAND") ? order.client : (client === 'DNS') ? order.resultTXT.ClaimNo != undefined ? order.resultTXT.ClaimNo : order.orderNo : order.orderNo}</td>
                                  {(client === 'SWISS' || client === "POLAND") &&
                                    <td scope="col" className="">
                                      {order && order.resultTXT && order.resultTXT && order && order.resultTXT && order.resultTXT.CustomerCompany ? order && order.resultTXT && order.resultTXT.CustomerCompany : '-'}
                                    </td>
                                  }
                                  {/* {((client === 'SWISS' || client === "POLAND") || UsCanada_partnerId.includes(partnerId)) &&   */}
                                  <td className="prio_row">{order.priority == "1" ?
                                    <span className="prio_icon">
                                      <img
                                        className=""
                                        src={require("../views/Dashboard/icon/icon-1.png")}
                                      />
                                    </span>
                                    : ""}
                                  </td>
                                  {/* } */}
                                  {/* {((client === 'SWISS' || client === "POLAND") || UsCanada_partnerId.includes(partnerId)) &&   */}
                                  <td className="Drive_through_in text-center">
                                    {(order && order.resultTXT && order.resultTXT && order && order.resultTXT && order.resultTXT.hasOwnProperty('DriveThrough')) ?
                                      ((order && order.resultTXT && order.resultTXT.DriveThrough == 1 && order && order.resultTXT && order.resultTXT.ReportGeneratedStatus !== "") ? (
                                        // 'IN'
                                        <>
                                          {order && order.resultTXT && order.resultTXT.ReportGeneratedStatus === "PASS" && order.resultTXT.ReportGenerated &&
                                            <i style={{ color: (order && order.resultTXT && order.resultTXT.hasOwnProperty('DATReportAuthorized') && (order && order.resultTXT && order.resultTXT.DATReportAuthorized && order && order.resultTXT && order.resultTXT.ReportGeneratedStatus === "PASS") ? "#FFD100" : "#d80707") }} class='fa fa-circle'></i>
                                          }
                                          {order && order.resultTXT && order.resultTXT.ReportGeneratedStatus === "PROCESSING" &&
                                            <i style={{ color: (order && order.resultTXT && order.resultTXT.hasOwnProperty('DATReportAuthorized') && (order && order.resultTXT && order.resultTXT.DATReportAuthorized && order && order.resultTXT && order.resultTXT.ReportGeneratedStatus === 'PROCESSING') ? "#b3b3b3" : "#b3b3b3") }} class="fa fa-circle"></i>
                                          }
                                          {order && order.resultTXT && order.resultTXT.ReportGeneratedStatus === "FAIL" &&
                                            <i style={{ color: "#D80707", fontSize: "20px" }} onClick={() => this.resetAuthorizeAPI(order.vin)} class="fa fa-exclamation-triangle"></i>
                                          }
                                        </>
                                      )
                                        : order && order.resultTXT && order.resultTXT.DriveThrough == 0 && order && order.resultTXT && order.resultTXT.ReportGeneratedStatus !== "" &&
                                        //  'TH'
                                        <>
                                          <>
                                            {order && order.resultTXT && order.resultTXT.ReportGeneratedStatus === "PASS" && order.resultTXT.ReportGenerated &&
                                              <>
                                                <i style={{ color: (order && order.resultTXT && order.resultTXT.hasOwnProperty('DATReportAuthorized') && (order && order.resultTXT && order.resultTXT.DATReportAuthorized && order && order.resultTXT && order.resultTXT.ReportGeneratedStatus === "PASS") ? "#FFD100" : "#d80707") }} class='fa fa-circle'></i>
                                                <i style={{ color: (order && order.resultTXT && order.resultTXT.hasOwnProperty('DATReportAuthorized') && (order && order.resultTXT && order.resultTXT.DATReportAuthorized && order && order.resultTXT && order.resultTXT.ReportGeneratedStatus === "PASS") ? "#FFD100" : "#d80707") }} class='fa fa-circle'></i>
                                                <i style={{ color: (order && order.resultTXT && order.resultTXT.hasOwnProperty('DATReportAuthorized') && (order && order.resultTXT && order.resultTXT.DATReportAuthorized && order && order.resultTXT && order.resultTXT.ReportGeneratedStatus === "PASS") ? "#FFD100" : "#d80707") }} class='fa fa-circle'></i>
                                              </>
                                            }
                                            {order && order.resultTXT && order.resultTXT.ReportGeneratedStatus === "PROCESSING" &&
                                              <>
                                                <i style={{ color: (order && order.resultTXT && order.resultTXT.hasOwnProperty('DATReportAuthorized') && (order && order.resultTXT && order.resultTXT.DATReportAuthorized && order && order.resultTXT && order.resultTXT.ReportGeneratedStatus === 'PROCESSING') ? "#b3b3b3" : "#b3b3b3") }} class="fa fa-circle"></i>
                                                <i style={{ color: (order && order.resultTXT && order.resultTXT.hasOwnProperty('DATReportAuthorized') && (order && order.resultTXT && order.resultTXT.DATReportAuthorized && order && order.resultTXT && order.resultTXT.ReportGeneratedStatus === 'PROCESSING') ? "#b3b3b3" : "#b3b3b3") }} class="fa fa-circle"></i>
                                                <i style={{ color: (order && order.resultTXT && order.resultTXT.hasOwnProperty('DATReportAuthorized') && (order && order.resultTXT && order.resultTXT.DATReportAuthorized && order && order.resultTXT && order.resultTXT.ReportGeneratedStatus === 'PROCESSING') ? "#b3b3b3" : "#b3b3b3") }} class="fa fa-circle"></i>
                                              </>
                                            }
                                            {order && order.resultTXT && order.resultTXT.ReportGeneratedStatus === "FAIL" &&
                                              <>
                                                <i style={{ color: "#D80707", fontSize: "20px" }} onClick={() => this.resetAuthorizeAPI(order.vin)} class="fa fa-exclamation-triangle"></i>
                                              </>
                                            }
                                          </>
                                        </>
                                      )
                                      :
                                      '-'
                                    }
                                  </td>
                                  {/* <td className="Drive_through_in text-center">
                                    {(order && order.resultTXT && order.resultTXT && order && order.resultTXT && order.resultTXT.hasOwnProperty('DriveThrough')) ? 
                                    ((order && order.resultTXT && order.resultTXT.DriveThrough == 1 && order && order.resultTXT && order.resultTXT.hasOwnProperty('ReportGenerated') && order && order.resultTXT && order.resultTXT.ReportGenerated == true) ? 
                                      // 'IN' 
                                      <i style={{color : (order.ReportGenerated == "1" ? (order && order.resultTXT && order.resultTXT.hasOwnProperty('DATReportAuthorized') && order && order.resultTXT && order.resultTXT.DATReportAuthorized ? "#FFD100" : "#d80707") : "#b3b3b3")}} class='fa fa-circle'></i>
                                    : order && order.resultTXT && order.resultTXT.DriveThrough == 0  && order && order.resultTXT && order.resultTXT.hasOwnProperty('ReportGenerated') && order && order.resultTXT && order.resultTXT.ReportGenerated == true &&
                                    //  'TH'
                                    <>
                                    <i style={{color : (order.ReportGenerated == "1" ? (order && order.resultTXT && order.resultTXT.hasOwnProperty('DATReportAuthorized') && order && order.resultTXT && order.resultTXT.DATReportAuthorized ? "#FFD100" : "#d80707") : "#b3b3b3")}} class='fa fa-circle'></i>
                                    <i style={{color : (order.ReportGenerated == "1" ? (order && order.resultTXT && order.resultTXT.hasOwnProperty('DATReportAuthorized') && order && order.resultTXT && order.resultTXT.DATReportAuthorized ? "#FFD100" : "#d80707") : "#b3b3b3")}} class='fa fa-circle'></i>
                                    <i style={{color : (order.ReportGenerated == "1" ? (order && order.resultTXT && order.resultTXT.hasOwnProperty('DATReportAuthorized') && order && order.resultTXT && order.resultTXT.DATReportAuthorized ? "#FFD100" : "#d80707") : "#b3b3b3")}} class='fa fa-circle'></i>
                                    </>
                                      ) 
                                      : 
                                      '-'
                                    }
                                  </td> */}
                                  {/* } */}
                                  <td className={`${(client === 'SWISS' || client === "POLAND") ? 'modal_row' : ''}`} title={order.make}>{order.make}</td>
                                  <td className={`${(client === 'SWISS' || client === "POLAND") ? 'modal_row' : ''}`} title={order.modal}>{order.modal}</td>
                                  {(client === 'SWISS' || client === "POLAND" || UsCanada_partnerId.includes(partnerId)) &&
                                    <td className="expert_name_column" onClick={() => this.updateExpert(order)}>
                                      <span className="show_expert_text" title={order.expert_name} >{order.expert_name} </span>
                                      {/* <span className="add_name_button"><i onClick={()=> this.updateExpert(order)} class='fa fa-plus'></i></span> */}
                                    </td>}
                                  <td>{(client === 'SWISS' || client === "POLAND") ? order.authorizer_name : order.color}
                                  {client === "SWISS" && (
                                      <p>
                                        {order.resultTXT
                                          .DuplicateChildPartnerId &&
                                          Array.isArray(
                                            order.resultTXT
                                              .DuplicateChildPartnerId
                                          ) &&
                                          order.resultTXT
                                            .DuplicateChildPartnerId.length > 0 && (
                                              <>
                                                {order.resultTXT.DuplicateChildPartnerId.join(', ')}
                                              </>
                                            )}
                                      </p>
                                    )}
                                  </td>
                                {client === "POLAND" && (
                                  <>
                                    <td >{order && order.resultTXT && order.resultTXT.ScannerLocation}</td>
                                    <td title={order && order.resultTXT && order.resultTXT.Revision}>{order && order.resultTXT && order.resultTXT.Revision}</td>
                                  </>
                                )}
                                  <td>{order.uploadDate ? this.formatDate(order.uploadDate.split(" ")[0]) : ""}</td>
                                  <td>{order.uploadDate ? order.uploadDate.split(" ")[1] : ""}</td>
                                  <td className={`text-center ${(client === 'SWISS' || client === "POLAND") ? 'counts_row' : ''}`}>{order.TotalDents}</td>
                                  <td className={`text-center ${(client === 'SWISS' || client === "POLAND") ? 'counts_row' : ''}`}>{order.TotalImages}</td>
                                  <td className={`text-center ${(client === 'SWISS' || client === "POLAND") ? 'counts_row' : ''}`}>{order.total_extra_images}</td>
                                  <td className={`${(client === 'SWISS' || client === "POLAND") ? 'last_report_row' : ''}`}>
                                    <div className="all_scan_report_table_btn m-auto">
                                      <div className="d-flex justify-content-center">
                                        <span style={{}}>
                                          {(client === "POLAND") ?
                                            <Link
                                              className="btn btn-outline-info text-decoration-none mr-1"
                                              style={{ fontSize: 17 }}
                                              // to={(client === 'DNS' || client === 'AUS')  && '/TabViewDNS' || client === 'FR' && '/TabViewSwissFrench' || (client === 'SWISS' || client === "POLAND") && '/newTabview' || client === 'OTHER' && '/TabView/slovani' || client === 'ROM' && '/TabView/romania' || client === 'CZ' && '/TabViewCZ' || client === 'AUT' && '/TabViewAUT'} 
                                              to={this.generateLink("TabView", "Poland")}
                                              target='_blank'
                                              onClick={() => {
                                                localStorage.setItem("selectedFile", order.vin);
                                              }}
                                            >
                                              <i className="fa fa-table" aria-hidden="true"></i> Tab
                                            </Link>
                                            : client == "SWISS" ? order.TotalDents != 0 ?
                                            <Link
                                            className="btn btn-outline-info text-decoration-none mr-1"
                                            style={{ fontSize: 17 }}
                                            // to={(client === 'DNS' || client === 'AUS')  && '/TabViewDNS' || client === 'FR' && '/TabViewSwissFrench' || (client === 'SWISS' || client === "POLAND") && '/newTabview' || client === 'OTHER' && '/TabView/slovani' || client === 'ROM' && '/TabView/romania' || client === 'CZ' && '/TabViewCZ' || client === 'AUT' && '/TabViewAUT'} 
                                            to={this.generateLink("TabView", "allClients")}
                                            target='_blank'
                                            onClick={() => {
                                              localStorage.setItem("selectedFile", order.vin);
                                            }}
                                          >
                                            <i className="fa fa-table" aria-hidden="true"></i> Tab
                                          </Link> : "" :
                                            <Link
                                              className="btn btn-outline-info text-decoration-none mr-1"
                                              style={{ fontSize: 17 }}
                                              // to={(client === 'DNS' || client === 'AUS')  && '/TabViewDNS' || client === 'FR' && '/TabViewSwissFrench' || (client === 'SWISS' || client === "POLAND") && '/newTabview' || client === 'OTHER' && '/TabView/slovani' || client === 'ROM' && '/TabView/romania' || client === 'CZ' && '/TabViewCZ' || client === 'AUT' && '/TabViewAUT'} 
                                              to={this.generateLink("TabView", "allClients")}
                                              target='_blank'
                                              onClick={() => {
                                                localStorage.setItem("selectedFile", order.vin);
                                              }}
                                            >
                                              <i className="fa fa-table" aria-hidden="true"></i> Tab
                                            </Link>
                                          }
                                        </span>
                                        {/* <span style={{}}>
                                      <Link
                                        className="btn btn-outline-info text-decoration-none mr-1"
                                        style={{ fontSize: 17 }}
                                        // to={(client === 'DNS' || client === 'AUS')  && '/TabViewDNS' || client === 'FR' && '/TabViewSwissFrench' || (client === 'SWISS' || client === "POLAND") && '/newTabview' || client === 'OTHER' && '/TabView/slovani' || client === 'ROM' && '/TabView/romania' || client === 'CZ' && '/TabViewCZ' || client === 'AUT' && '/TabViewAUT'} 
                                        to={this.generateLink("TabView")}
                                        target='_blank'
                                        onClick={() => {
                                          localStorage.setItem("selectedFile", order.vin);
                                        }}
                                      >
                                        <i className="fa fa-table" aria-hidden="true"></i> Tab  
                                      </Link>
                                    </span> */}
                                        {(client !== "SWISS" && client !== "POLAND") &&
                                          <>
                                            <span style={{}}>
                                              <Link
                                                className="btn btn-outline-info text-decoration-none mr-1"
                                                style={{ fontSize: 17 }}
                                                // to="/ReportMini"
                                                // to={(client === 'DNS' || client === 'AUS')  && '/ReportMiniDNS' || client === 'FR' && '/ReportMiniSwissFrench' || (client === 'SWISS' || client === "POLAND") && '/newReportMini' || client === 'OTHER' && '/ReportMini/slovani' || client === 'ROM' && '/ReportMini/romania' || client === 'CZ' && '/ReportMiniCZ' || client === "AUT" && '/ReportMiniAUT'}
                                                to={this.generateLink("ReportMini")}
                                                target='_blank'
                                                onClick={() => {
                                                  localStorage.setItem("selectedFile", order.vin);
                                                }}
                                              >
                                                <i className="fa fa-file-text-o" aria-hidden="true"></i> Mini
                                              </Link>
                                            </span>
                                            <span style={{}}>
                                              <Link
                                                className="btn btn-outline-info text-decoration-none mr-1"
                                                style={{ fontSize: 17 }}
                                                // to="/ReportFull"
                                                // to={(client === 'DNS' || client === 'AUS')  && '/ReportFullDNS' || client === 'FR' && '/ReportFullSwissFrench' || (client === 'SWISS' || client === "POLAND") && '/newReportFull' || client === 'OTHER' && '/ReportFull/slovani' || client === 'ROM' && '/ReportFull/romania' || client === 'CZ' && '/ReportFullCZ' || client === 'AUT' && '/ReportFullAUT'}
                                                to={this.generateLink("ReportFull")}
                                                target='_blank'
                                                onClick={() => {
                                                  localStorage.setItem("selectedFile", order.vin);
                                                }}
                                              >
                                                <i className="fa fa-file-pdf-o" aria-hidden="true"></i> Full
                                              </Link>
                                            </span>
                                          </>
                                        }
                                      </div>
                                    </div>
                                  </td>
                                  {(client === 'SWISS' || client === "POLAND") &&
                                    <td>
                                      <div className="all_scan_report_table_btn m-auto">
                                        <span>
                                          <button
                                            className="btn btn-outline-info text-decoration-none mr-1"
                                            style={{ fontSize: 17 }}
                                            onClick={() => {
                                              try {
                                                localStorage.setItem("selectedFile", order.vin);
                                                window.open(window.location.origin + "/gallery", "_blank", `width=${window.outerWidth},height=${window.outerHeight}`)
                                              } catch (error) {
                                                console.error("An error occurred:", error);
                                              }
                                            }}
                                          >
                                            {this.lang("Image")}
                                          </button>
                                        </span>
                                      </div>
                                    </td>}
                                </tr>
                              )
                            })
                            :
                            !search_status && !loading &&
                            <tr>
                              <td colSpan={13} className="text-center" ref={el => {
                                if (el) {
                                  el.style.setProperty('text-align', 'center', 'important');
                                }
                              }}>
                                {this.lang("No Data Found")}
                              </td>
                            </tr>
                          }
                          {search_status && !loading && result && result.length ?
                            result.map((order, i) => (
                              <tr key={i}>
                                <td className={`${(client === 'SWISS' || client === "POLAND") ? 'sr_no_row' : ''}`}>{(searchCurrentPage - 1) * (recordsPerPage ? parseInt(recordsPerPage) : 10) + i + 1}</td>
                                <td style={{ color: ((order && order.resultTXT && order.resultTXT.DriveThrough == "1" || order && order.resultTXT && order.resultTXT.DriveThrough == "0") && order && order.resultTXT && order.resultTXT.ReportGenerated == true ? "#006400" : "#F20000") }}  >
                                  {order.vin || order && order.resultTXT && order.resultTXT && order && order.resultTXT && order.resultTXT.ActualVin}</td>
                                {/* {(client === 'SWISS' || client === "POLAND") && <td scope="col">{order && order.resultTXT && order.resultTXT && order && order.resultTXT && order.resultTXT.ActualVin}</td>} */}
                                <td className={`${(client === 'SWISS' || client === "POLAND") ? 'insurance_client_row' : ''}`} title={order.client}>
                                  {(client === 'SWISS' || client === "POLAND")
                                    ? order.client
                                    : (client === 'DNS')
                                      ? (order.resultTXT && order.resultTXT.ClaimNo !== undefined)
                                        ? order.resultTXT.ClaimNo
                                        : order.orderNo
                                      : order.orderNo}
                                </td>

                                {(client === 'SWISS' || client === "POLAND") &&
                                  <td scope="col" className="">
                                    {order && order.resultTXT && order.resultTXT && order && order.resultTXT && order.resultTXT.CustomerCompany ? order && order.resultTXT && order.resultTXT.CustomerCompany : '-'}
                                  </td>
                                }
                                {/* {((client === 'SWISS' || client === "POLAND") || client === "DNS" || UsCanada_partnerId.includes(partnerId))  &&  */}
                                <td>{order.priority == "1" ?
                                  <span className="prio_icon">
                                    <img
                                      className=""
                                      src={require("../views/Dashboard/icon/icon-1.png")}
                                    />
                                  </span>
                                  : ""}
                                </td>
                                {/* } */}
                                {/* {((client === 'SWISS' || client === "POLAND") || client === "DNS" || UsCanada_partnerId.includes(partnerId)) &&  */}
                                {/* <td className="Drive_through_in text-center">
                                    {(order && order.resultTXT && order.resultTXT && order && order.resultTXT && order.resultTXT.hasOwnProperty('DriveThrough')) ? 
                                    ((order && order.resultTXT && order.resultTXT.DriveThrough == 1 && order && order.resultTXT && order.resultTXT.hasOwnProperty('ReportGenerated') && order && order.resultTXT && order.resultTXT.ReportGenerated == true) ? 
                                      // 'IN' 
                                      <i style={{color : (order.ReportGenerated == "1" ? (order && order.resultTXT && order.resultTXT.hasOwnProperty('DATReportAuthorized') && order && order.resultTXT && order.resultTXT.DATReportAuthorized ? "#FFD100" : "#d80707") : "#b3b3b3")}} class='fa fa-circle'></i>
                                    : order && order.resultTXT && order.resultTXT.DriveThrough == 0  && order && order.resultTXT && order.resultTXT.hasOwnProperty('ReportGenerated') && order && order.resultTXT && order.resultTXT.ReportGenerated == true &&
                                    //  'TH'
                                    <>
                                    <i style={{color : (order.ReportGenerated == "1" ? (order && order.resultTXT && order.resultTXT.hasOwnProperty('DATReportAuthorized') && order && order.resultTXT && order.resultTXT.DATReportAuthorized ? "#FFD100" : "#d80707") : "#b3b3b3")}} class='fa fa-circle'></i>
                                    <i style={{color : (order.ReportGenerated == "1" ? (order && order.resultTXT && order.resultTXT.hasOwnProperty('DATReportAuthorized') && order && order.resultTXT && order.resultTXT.DATReportAuthorized ? "#FFD100" : "#d80707") : "#b3b3b3")}} class='fa fa-circle'></i>
                                    <i style={{color : (order.ReportGenerated == "1" ? (order && order.resultTXT && order.resultTXT.hasOwnProperty('DATReportAuthorized') && order && order.resultTXT && order.resultTXT.DATReportAuthorized ? "#FFD100" : "#d80707") : "#b3b3b3")}} class='fa fa-circle'></i>
                                    </>
                                      ) 
                                    : 
                                    '-'
                                    }
                                  </td> */}
                                <td className="Drive_through_in text-center">
                                  {(order && order.resultTXT && order.resultTXT && order && order.resultTXT && order.resultTXT.hasOwnProperty('DriveThrough')) ?
                                    ((order && order.resultTXT && order.resultTXT.DriveThrough == 1 && order && order.resultTXT && order.resultTXT.ReportGeneratedStatus !== "") ? (
                                      // 'IN'
                                      <>
                                        {order && order.resultTXT && order.resultTXT.ReportGeneratedStatus === "PASS" &&
                                          <i style={{ color: (order && order.resultTXT && order.resultTXT.hasOwnProperty('DATReportAuthorized') && (order && order.resultTXT && order.resultTXT.DATReportAuthorized && order && order.resultTXT && order.resultTXT.ReportGeneratedStatus === "PASS") ? "#FFD100" : "#d80707") }} class='fa fa-circle'></i>
                                        }
                                        {order && order.resultTXT && order.resultTXT.ReportGeneratedStatus === "PROCESSING" &&
                                          <i style={{ color: (order && order.resultTXT && order.resultTXT.hasOwnProperty('DATReportAuthorized') && (order && order.resultTXT && order.resultTXT.DATReportAuthorized && order && order.resultTXT && order.resultTXT.ReportGeneratedStatus === 'PROCESSING') ? "#b3b3b3" : "#b3b3b3") }} class="fa fa-circle"></i>
                                        }
                                        {order && order.resultTXT && order.resultTXT.ReportGeneratedStatus === "FAIL" &&
                                          <i style={{ color: "#D80707", fontSize: "20px" }} onClick={() => this.resetAuthorizeAPI(order.vin)} class="fa fa-exclamation-triangle"></i>
                                        }
                                      </>
                                    )
                                      : order && order.resultTXT && order.resultTXT.DriveThrough == 0 && order && order.resultTXT && order.resultTXT.ReportGeneratedStatus !== "" &&
                                      //  'TH'
                                      <>
                                        <>
                                          {order && order.resultTXT && order.resultTXT.ReportGeneratedStatus === "PASS" &&
                                            <>
                                              <i style={{ color: (order && order.resultTXT && order.resultTXT.hasOwnProperty('DATReportAuthorized') && (order && order.resultTXT && order.resultTXT.DATReportAuthorized && order && order.resultTXT && order.resultTXT.ReportGeneratedStatus === "PASS") ? "#FFD100" : "#d80707") }} class='fa fa-circle'></i>
                                              <i style={{ color: (order && order.resultTXT && order.resultTXT.hasOwnProperty('DATReportAuthorized') && (order && order.resultTXT && order.resultTXT.DATReportAuthorized && order && order.resultTXT && order.resultTXT.ReportGeneratedStatus === "PASS") ? "#FFD100" : "#d80707") }} class='fa fa-circle'></i>
                                              <i style={{ color: (order && order.resultTXT && order.resultTXT.hasOwnProperty('DATReportAuthorized') && (order && order.resultTXT && order.resultTXT.DATReportAuthorized && order && order.resultTXT && order.resultTXT.ReportGeneratedStatus === "PASS") ? "#FFD100" : "#d80707") }} class='fa fa-circle'></i>
                                            </>
                                          }
                                          {order && order.resultTXT && order.resultTXT.ReportGeneratedStatus === "PROCESSING" &&
                                            <>
                                              <i style={{ color: (order && order.resultTXT && order.resultTXT.hasOwnProperty('DATReportAuthorized') && (order && order.resultTXT && order.resultTXT.DATReportAuthorized && order && order.resultTXT && order.resultTXT.ReportGeneratedStatus === 'PROCESSING') ? "#b3b3b3" : "#b3b3b3") }} class="fa fa-circle"></i>
                                              <i style={{ color: (order && order.resultTXT && order.resultTXT.hasOwnProperty('DATReportAuthorized') && (order && order.resultTXT && order.resultTXT.DATReportAuthorized && order && order.resultTXT && order.resultTXT.ReportGeneratedStatus === 'PROCESSING') ? "#b3b3b3" : "#b3b3b3") }} class="fa fa-circle"></i>
                                              <i style={{ color: (order && order.resultTXT && order.resultTXT.hasOwnProperty('DATReportAuthorized') && (order && order.resultTXT && order.resultTXT.DATReportAuthorized && order && order.resultTXT && order.resultTXT.ReportGeneratedStatus === 'PROCESSING') ? "#b3b3b3" : "#b3b3b3") }} class="fa fa-circle"></i>
                                            </>
                                          }
                                          {order && order.resultTXT && order.resultTXT.ReportGeneratedStatus === "FAIL" &&
                                            <>
                                              <i style={{ color: "#D80707", fontSize: "20px" }} onClick={() => this.resetAuthorizeAPI(order.vin)} class="fa fa-exclamation-triangle"></i>
                                            </>
                                          }
                                        </>
                                      </>
                                    )
                                    :
                                    '-'
                                  }
                                </td>
                                {/* } */}
                                <td className={`${(client === 'SWISS' || client === "POLAND") ? 'modal_row' : ''}`} title={order.make}>{order.make}</td>
                                <td className={`${(client === 'SWISS' || client === "POLAND") ? 'modal_row' : ''}`} title={order.modal}>{order.modal}</td>
                                {(client === 'SWISS' || client === "POLAND" || UsCanada_partnerId.includes(partnerId)) &&
                                  <td className="expert_name_column">
                                    <span className="show_expert_text" title={order.expert_name} onClick={() => this.updateExpert(order)}>{order.expert_name} </span>
                                    {/* <span className="add_name_button"><i onClick={()=> this.updateExpert(order)} class='fa fa-plus'></i></span> */}
                                  </td>}
                                <td>{(client === 'SWISS' || client === "POLAND") ? order.authorizer_name : order.color}
                                {client === "SWISS" && (
                                      <span>
                                        {order && order.resultTXT && order.resultTXT
                                          .DuplicateChildPartnerId &&
                                          Array.isArray(
                                            order.resultTXT
                                              .DuplicateChildPartnerId
                                          ) &&
                                          order.resultTXT
                                            .DuplicateChildPartnerId.length > 0 && (
                                              <>
                                                <br /> {/* Add line break */}
                                                {order.resultTXT.DuplicateChildPartnerId.join(', ')}
                                              </>
                                            )}
                                      </span>
                                    )}
                                </td>
                                {client === "POLAND" && (<>
                                  <td>{order && order.resultTXT && order.resultTXT.ScannerLocation}</td>
                                  <td title={order && order.resultTXT && order.resultTXT.Revision}>{order && order.resultTXT && order.resultTXT.Revision}</td>
                                </>)}
                                <td>{order.uploadDate ? this.formatDate(order.uploadDate.split(" ")[0]) : ""}</td>
                                <td>{order.uploadDate ? order.uploadDate.split(" ")[1] : ""}</td>
                                <td className={`text-center ${(client === 'SWISS' || client === "POLAND") ? 'counts_row' : ''}`}>{order.TotalDents}</td>
                                <td className={`text-center ${(client === 'SWISS' || client === "POLAND") ? 'counts_row' : ''}`}>{order.TotalImages}</td>
                                <td className={`text-center ${(client === 'SWISS' || client === "POLAND") ? 'counts_row' : ''}`}>{order.total_extra_images}</td>
                                <td className={`${(client === 'SWISS' || client === "POLAND") ? 'last_report_row' : ''}`}>
                                  <div className="all_scan_report_table_btn m-auto">
                                    <div className="d-flex justify-content-center">
                                      <span style={{}}>
                                      {client == "SWISS" ? order.TotalDents != 0 ?
                                        <Link
                                          className="btn btn-outline-info text-decoration-none mr-1"
                                          style={{ fontSize: 17 }}
                                          // to="/TabView"
                                          to={(client === 'DNS' || client === 'AUS') && '/TabViewDNS' || client === 'FR' && '/TabViewSwissFrench' || client === "POLAND" && '/PolandTabview' || (client === 'SWISS' || client === "POLAND") && '/newTabview' || client === 'OTHER' && '/TabView/slovani' || client === 'ROM' && '/TabView/romania' || client === 'CZ' && '/TabViewCZ' || client === 'AUT' && '/TabViewAUT' || client === 'US' && '/TabViewUS' || client === 'CANADA' && '/Canada/TabView'}
                                          target='_blank'
                                          onClick={() => {
                                            localStorage.setItem("selectedFile", order.vin);
                                          }}
                                        >
                                          <i className="fa fa-table" aria-hidden="true"></i> Tab
                                        </Link> : "" :  <Link
                                          className="btn btn-outline-info text-decoration-none mr-1"
                                          style={{ fontSize: 17 }}
                                          // to="/TabView"
                                          to={(client === 'DNS' || client === 'AUS') && '/TabViewDNS' || client === 'FR' && '/TabViewSwissFrench' || client === "POLAND" && '/PolandTabview' || (client === 'SWISS' || client === "POLAND") && '/newTabview' || client === 'OTHER' && '/TabView/slovani' || client === 'ROM' && '/TabView/romania' || client === 'CZ' && '/TabViewCZ' || client === 'AUT' && '/TabViewAUT' || client === 'US' && '/TabViewUS' || client === 'CANADA' && '/Canada/TabView'}
                                          target='_blank'
                                          onClick={() => {
                                            localStorage.setItem("selectedFile", order.vin);
                                          }}
                                        >
                                          <i className="fa fa-table" aria-hidden="true"></i> Tab
                                        </Link> }
                                      </span>
                                      {(client !== "SWISS" && client !== "POLAND") &&
                                        <>
                                          <span style={{}}>
                                            <Link
                                              className="btn btn-outline-info text-decoration-none mr-1"
                                              style={{ fontSize: 17 }}
                                              // to="/ReportMini"
                                              to={(client === 'DNS' || client === 'AUS') && '/ReportMiniDNS' || client === 'FR' && '/ReportMiniSwissFrench' || (client === 'SWISS' || client === "POLAND") && '/newReportMini' || client === 'OTHER' && '/ReportMini/slovani' || client === 'ROM' && '/ReportMini/romania' || client === 'CZ' && '/ReportMiniCZ' || client === "AUT" && '/ReportMiniAUT' || client === 'US' && '/ReportMiniUS' || client === 'CANADA' && '/Canada/ReportMini'}
                                              target='_blank'
                                              onClick={() => {
                                                localStorage.setItem("selectedFile", order.vin);
                                              }}
                                            >
                                              <i className="fa fa-file-text-o" aria-hidden="true"></i> Mini
                                            </Link>
                                          </span>
                                          <span style={{}}>
                                            <Link
                                              className="btn btn-outline-info text-decoration-none mr-1"
                                              style={{ fontSize: 17 }}
                                              // to="/ReportFull"
                                              to={(client === 'DNS' || client === 'AUS') && ((partnerId == "5-200126" || partnerId == "24-230315" || partnerId == "11-210601") ? '/ReportFullGeneralDamageImage' : '/ReportFullDNS') || client === 'FR' && '/ReportFullSwissFrench' || (client === 'SWISS' || client === "POLAND") && '/newReportFull' || (client === 'OTHER' && (partnerId == "5-200126" || partnerId == "24-230315" || partnerId == "11-210601") ? '/ReportFullGeneralDamageImage' :  '/ReportFull/slovani') || client === 'ROM' && '/ReportFull/romania' || client === 'CZ' && '/ReportFullCZ' || client === 'AUT' && '/ReportFullAUT' || client === 'US' && '/ReportFullUS' || client === 'CANADA' && '/Canada/ReportFullCA'}
                                              target='_blank'
                                              onClick={() => {
                                                localStorage.setItem("selectedFile", order.vin);
                                              }}
                                            >
                                              <i className="fa fa-file-pdf-o" aria-hidden="true"></i> Full
                                            </Link>
                                          </span>
                                        </>
                                      }
                                    </div>
                                  </div>
                                </td>
                                {(client === 'SWISS' || client === "POLAND") &&
                                  <td>
                                    <div className="all_scan_report_table_btn m-auto">
                                      <span>
                                        <button
                                          className="btn btn-outline-info text-decoration-none mr-1"
                                          style={{ fontSize: 17 }}
                                          onClick={() => {
                                            try {
                                              localStorage.setItem("selectedFile", order.vin);
                                              window.open(window.location.origin + "/gallery", "_blank", `width=${window.outerWidth},height=${window.outerHeight}`)
                                            } catch (error) {
                                              console.error("An error occurred:", error);
                                            }
                                          }}
                                        >
                                          {this.lang("Image")}
                                        </button>
                                      </span>
                                    </div>
                                  </td>}
                              </tr>
                            ))
                            :
                            search_status && !loading &&
                            <tr>
                              <td colSpan={13} className="text-center" ref={el => {
                                if (el) {
                                  el.style.setProperty('text-align', 'center', 'important');
                                }
                              }}>
                                {this.lang("No Data Found")}
                              </td>
                            </tr>
                          }
                        </tbody>
                      </table>

                    </div>
                  </div>
                </div>
                <div className="text-right qr_table_footer">
                  <div className="row justify-content-end">
                    <div className="col-lg-5 col-md-6 col-sm-12">
                      <nav aria-label="Page navigation example">
                        <ul className="pagination justify-content-end">
                          {!search_status ?
                            (
                              <>
                                <li className="page-item disabled">
                                  <button className="btn" disabled={previous_page === null} onClick={() => this.getVinList(previous_page)}>
                                    <i className="fa fa-angle-double-left" aria-hidden="true"></i></button>
                                </li>

                                {previous_page && <li className="page-item"><button className="btn" onClick={() => this.getVinList(previous_page)}>{previous_page}</button></li>}

                                <li className="page-item active"><button className="btn" onClick={() => this.getVinList(current_page)}>{current_page === null ? 1 : current_page}</button></li>
                                {next_page && <li className="page-item" onClick={() => this.getVinList(next_page)}><button className="btn">{next_page}</button></li>}
                                <li className="page-item">
                                  <button className="btn" disabled={next_page && next_page === null} onClick={() => this.getVinList(next_page)}><i className="fa fa-angle-double-right" aria-hidden="true"></i></button>
                                </li>
                              </>
                            )
                            :
                            (result && result.length ?
                              <>
                                <li className="page-item disabled">
                                  <button className="btn" disabled={searchPreviousPage === null} onClick={() => this.search(searchPreviousPage)}>
                                    <i className="fa fa-angle-double-left" aria-hidden="true"></i>
                                  </button>
                                </li>

                                {searchPreviousPage && (
                                  <li className="page-item">
                                    <button className="btn" onClick={() => this.search(searchPreviousPage)}>
                                      {searchPreviousPage}
                                    </button>
                                  </li>
                                )}

                                <li className="page-item active">
                                  <button className="btn" onClick={() => this.search(searchCurrentPage)}>
                                    {searchCurrentPage === null ? 1 : searchCurrentPage}
                                  </button>
                                </li>
                                {searchNextPage && (
                                  <li className="page-item" onClick={() => this.search(searchNextPage)}>
                                    <button className="btn">{searchNextPage}</button>
                                  </li>
                                )}
                                <li className="page-item">
                                  <button className="btn" disabled={searchNextPage === null} onClick={() => this.search(searchNextPage)}>
                                    <i className="fa fa-angle-double-right" aria-hidden="true"></i>
                                  </button>
                                </li>
                              </>
                              :
                              ""
                            )
                          }
                        </ul>
                      </nav>
                    </div>
                  </div>
                </div>

                <Modal size="md" isOpen={this.state.modal} centered="true" className="expert_name_moda_wrapper" backdrop="static" toggle={() =>
                  this.setState({ modal: false })}>
                  <ModalBody className="text-center">
                    <div className="form-group">
                      <input type="text" name="inputValue" value={this.state.inputValue}
                        onChange={this.handleInputChange}
                        onKeyPress={(e) => {
                          if (e.key === 'Enter') {
                            e.preventDefault()
                            this.handleExperte()
                          }
                        }} />
                    </div>
                    <div className="expert_modal_bottom_footer">
                      <button className="btn btn-cancel p-2 mr-2" onClick={() => this.setState({ modal: false })}> {this.lang("Cancel")} </button>
                      <button className="btn btn-danger p-2" onClick={this.handleExperte}> {this.lang("Update")} </button>

                    </div>
                  </ModalBody>
                </Modal>
              </div>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

export default AllScanRecords;